<template>
  <div class="sellers-management-form">
    <form @submit.stop.prevent="newSeller.seller && newSeller.seller.company_management_user_id ? editSeller() : addSeller()">
      <b-row>
        <b-col>
          <b-card v-if="newSeller.seller">
            <span v-if="!newSeller.seller || !newSeller.seller.company_management_user_id" class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; left: 0" href="#" @click.prevent="newSeller.seller = null">×</span>
            <user-card :user="newSeller.seller" />
          </b-card>
          <div class="form-group" v-else>
            <label for="search-seller" class="d-inline-block" style="width: 80px;" v-translate>Seller</label>
            <user-autocomplete ref="sellerAc" placeholder="Seller Name or Email" @selected="onSearchSellerSelected" :restrictToRoles="['commercial', 'super-admin']" with-picture />
          </div>
          <b-form-group class="mt-2">
            <label for="since" class="d-inline-block" style="width: 80px;" v-translate>Since</label>
            <input type="date" id="since" v-model="newSeller.relationship_date" class="form-control" style="width: auto; display: inline-block" required>
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="until" class="d-inline-block" style="width: 80px;" v-translate>Until</label>
            <input type="date" id="until" v-model="newSeller.relationship_end" class="form-control" style="width: auto; display: inline-block">
          </b-form-group>
          <b-form-group class="mt-2">
            <label for="region" class="d-inline-block" style="width: 80px;" v-translate>Region</label>
            <b-form-select v-model="newSeller.region" :options="regions" class="mb-3">
              <option slot="first" :value="null">
                <translate>All Regions</translate>
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <div class="text-right form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" :disabled="!newSeller.seller || !newSeller.relationship_date">
            <span v-if="newSeller.seller && newSeller.seller.company_management_user_id" v-translate>Edit Seller</span>
            <span v-else v-translate>Add Seller</span>
          </b-button>
          <b-button type="button" variant="outline-primary" size="lg" @click.prevent="emitCancel" v-translate>Cancel</b-button>
        </div>
      </b-row>
    </form>
  </div>
</template>

<script>
import UserCard from '@/components/UserCard'
import UserAutocomplete from '@/components/autocompletes/UserAutocomplete'

export default {
  name: 'SellersManagementForm',
  components: {
    UserCard,
    UserAutocomplete
  },
  props: {
    company: {
      type: Object,
      default: () => {},
      required: true
    },
    newSeller: {
      type: Object,
      default: () => {}
    },
    regions: {
      type: Array,
      default: () => [],
      required: true
    },
    region: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      currentSeller: null,
      sellers: [],
      showPreviousSellers: false,
      searchSellerQuery: '',
      sellerAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Commercial Name or Email'),
        inputClass: 'form-control'
      }
    }
  },
  mounted() {
    if (this.region) {
      this.newSeller.region = this.region
    }
  },
  methods: {
    onSearchSellerSelected(item) {
      this.newSeller.seller = item
      this.searchSellerQuery = ''
    },
    addSeller() {
      let payload = {
        user_id: this.newSeller.seller.id,
        company_id: this.company.id + '',
        relationship: 'seller',
        relationship_date: this.moment(this.newSeller.relationship_date).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        relationship_end: this.newSeller.relationship_end ? this.moment(this.newSeller.relationship_end).endOf('day').format('YYYY-MM-DD HH:mm:ss') : null,
        region_id: this.newSeller.region || null
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'companies-management-users', payload)
        .then(response => {
          this.emitSuccess()
        })
    },
    editSeller() {
      if (
        confirm(this.$gettext('Are you sure you want to EDIT this Seller from this Company?'))
      ) {
        let payload = {
          user_id: this.newSeller.seller.id,
          company_id: this.company.id + '',
          relationship: 'seller',
          relationship_date: this.moment(this.newSeller.relationship_date).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          relationship_end: this.newSeller.relationship_end ? this.moment(this.newSeller.relationship_end).endOf('day').format('YYYY-MM-DD HH:mm:ss') : null,
          region_id: this.newSeller.region
        }
        this.$http.patch(this.$appConfig.api.baseUrl + 'companies-management-users/' + this.newSeller.seller.company_management_user_id, payload)
          .then(response => {
            this.emitSuccess()
          })
      }
    },
    emitSuccess() {
      this.$emit('success', true)
    },
    emitCancel() {
      this.$emit('cancel', true)
    }
  }
}
</script>
